const reportRoutes = [
	{
		path: '/template/configuration',
		name: 'templateConfiguration',
		component: () => import('../home')
	}
]
export default reportRoutes
